<template>
    <div
        v-if="organizationFinances?.balance || organizationFinances?.deposit > 0 || organizationFinances?.deposit < 0"
        class="account-balance wrapper"
    >
        <v-card v-if="show" class="px-2 d-flex align-center text-body-2">
            <div v-if="organizationFinances?.balance">
                {{ `${$t('balance')}:` }}
                <span :class="{'text-error': organizationFinances && organizationFinances?.balance <= 0}">
                    {{ $filters.priceFormat(organizationFinances.balance, organizationFinances.currency) }}
                </span>
            </div>
            <div v-if="organizationFinances?.deposit > 0 || organizationFinances?.deposit < 0" class="ml-4 mr-2">
                {{ `${$t('deposit')}:` }}
                <span>
                    {{ $filters.priceFormat(organizationFinances.deposit, organizationFinances.currency) }}
                </span>
            </div>
            <v-btn color="primary" icon="mdi-menu-right" variant="text" @click="show = !show" />
        </v-card>
        <v-btn v-else color="primary" icon="mdi-cash-sync" variant="text" class="bg-white" @click="show = !show" />
    </div>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class AccountBalance extends Vue {
        organizationFinances = null

        async mounted() {
            await this.$store.restored

            try {
                this.organizationFinances = await this.$api.organizationFinances.get()
            } catch (e) {
                this.organizationFinances = null
            }
        }

        get show() {
            return persistentStore.showAccountBalance
        }

        set show(val) {
            persistentStore.SET_SHOW_ACCOUNT_BALANCE(val)
        }
    }
    export default AccountBalance
</script>

<style lang="scss" scoped>
    .wrapper {
        position: absolute;
        top: 110px;
        right: 12px;
        z-index: 1;
    }
</style>
